import React from 'react';
import { translateCodes } from '../../../locales';
import { AppButton } from '../../buttons';
import { Block, FlexBox } from '../../layouts';

interface FormModalFooterProps {
    readonly onCancel?: () => void;
    readonly onOk?: () => void;
    readonly cancelTextCode?: string;
    readonly okTextCode?: string;
    readonly isLoadingButton?: boolean;
    readonly useSubmitButton?: boolean;
    readonly extraFooter?: React.ReactNode;
    readonly disabledSubmit?: boolean;
    readonly flex?: React.CSSProperties['flex'];
}

export const FormModalFooter = (props: FormModalFooterProps) => {
    const { onCancel, onOk, isLoadingButton, cancelTextCode, okTextCode, extraFooter, disabledSubmit } = props;

    return (
        <Block className='modal-footer'>
            <FlexBox justifyContent='space-between'>
                <FlexBox flex={'none'}>
                    {extraFooter && extraFooter}
                </FlexBox>
                <FlexBox gap={16} justifyContent='flex-end'>
                    {onCancel && (
                        <AppButton
                            translateCode={cancelTextCode}
                            onClick={onCancel}
                            flex={props.flex}
                        />
                    )}
                    {onOk && (
                        <AppButton
                            type='primary'
                            loading={isLoadingButton}
                            translateCode={okTextCode}
                            onClick={onOk}
                            flex={props.flex}
                        />
                    )}
                    {props.useSubmitButton && (
                        <AppButton
                            type={disabledSubmit ? 'default' : 'primary'}
                            loading={isLoadingButton}
                            translateCode={okTextCode}
                            htmlType='submit'
                            disabled={disabledSubmit}
                            flex={props.flex}
                        />
                    )}
                </FlexBox>
            </FlexBox>
        </Block>
    );
};

FormModalFooter.defaultProps = {
    cancelTextCode: translateCodes.CANCEL,
    okTextCode: translateCodes.OK,
    isLoadingButton: false,
};
